import { gql } from '@apollo/client';

export const SAVE_PROPERTY = gql`
  mutation saveProperty($input: SavePropertyInput) {
    saveProperty(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_PROPERTY_DETAILS = gql`
  mutation Mutation($input: PropertyDetailsInput) {
    addOrUpdatePropertyDetails(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_PROPERTY_USER_GROUPS = gql`
  mutation addOrUpdatePropertyUserGroups($input: PropertyUserGroupsInput) {
    addOrUpdatePropertyUserGroups(input: $input) {
      commandId
    }
  }
`;
